import { RentalServiceFeeByLeaseType } from './base'

export enum RentalContractName {
  TENANT_FINDER = 'TENANT_FINDER',
  FULL_MANAGEMENT = 'FULL_MANAGEMENT',
  ROOM_RENTAL = 'ROOM_RENTAL',
  MLS = 'MLS',
  MLS_MANAGEMENT = 'MLS_MANAGEMENT',
  PRODUCT_ONLY = 'PRODUCT_ONLY',
  TENANT_FINDER_AGENT = 'TENANT_FINDER_AGENT',
  CUSTOM = 'CUSTOM',
}

export type RentalContract = {
  id: string
  name: string
  serviceFeeByLeaseType?: RentalServiceFeeByLeaseType
}
